import Text from '@ingka/text';
import person from '@ingka/ssr-icon/paths/person';
import Button from '@ingka/button';
import { selectName, useAppSelector } from '@lotta/self-service/lottery-fe/data-access-state';
import { LinkWithLocale } from '@lotta/self-service/lottery-fe/ui-common';
import { useTranslation } from 'react-i18next';
import { useState } from 'react';
import { ProfileSlider } from './components/profile-slider/ProfileSlider';
import styles from './Header.module.scss';

/* eslint-disable-next-line */
export type HeaderProps = {};

const LOTTA = 'Lotta';

export const Header: React.FC<HeaderProps> = () => {
  const logoSource = `../../assets/logo/ikea-logo.png`;
  const { t } = useTranslation();
  let userName = useAppSelector(selectName);
  userName = userName ? userName : '';
  const [modalVisible, setModalVisible] = useState(false);

  return (
    <div data-testid="header-div">
      <div className={styles['header-div']}>
        <LinkWithLocale to="/" className={styles['button-link']} data-testid="lotta-btn">
          <div className={styles['logo-div']}>
            <img src={logoSource} alt="IKEA" />
            <Text tagName="h2" headingSize="m">
              {LOTTA}
            </Text>
          </div>
        </LinkWithLocale>
        <div className={styles['button-div']}>
          <LinkWithLocale to="/" className={styles['button-link']}>
            <Button
              type="tertiary"
              text={`${t('header-overview-btn')}`}
              data-testid="overview-btn"
            />
          </LinkWithLocale>
          {/* <LinkWithLocale to="/statistics" className={styles['button-link']}>
            <Button
              type="tertiary"
              text={`${t('header-statistics-btn')}`}
              data-testid="statistics-btn"
            />
          </LinkWithLocale> */}
          <LinkWithLocale to="/user-guide" className={styles['button-link']}>
            <Button
              type="tertiary"
              text={`${t('header-user-guide-btn')}`}
              data-testid="user-guide-btn"
            />
          </LinkWithLocale>
          <Button
            type="tertiary"
            text={`${t('header-user-name', { userName })}`}
            ssrIcon={person}
            className={styles['user-button']}
            onClick={() => setModalVisible(true)}
          />
          <ProfileSlider
            modalVisible={modalVisible}
            handleCloseBtn={() => setModalVisible(false)}
          />
        </div>
      </div>
      <div className={styles['hr-div']}>
        <hr className="demo-divider__hr-horizontal" />
      </div>
    </div>
  );
};
